export enum TIP_CATEGORY {
  IMAGE = 'image',
  MULTI_IMAGE = 'multiImage',
  VIDEO = 'video',
}

export interface ButtonConfig {
  btn_text: string;
  btn_url: string;
}

export interface MediaContent {
  url: string;
  size: string;
  alt: string;
  id: string;
  btn_text?: string;
  btn_url?: string;
}

export type ImageContent = MediaContent & { __image: never };

export type VideoContent = MediaContent & { __video: never };

export type MultiImageContent = MediaContent[] & { __multiImage: never };

interface BaseTip {
  id: string;
  title: string;
  description: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

interface ImageTip extends BaseTip {
  category: TIP_CATEGORY.IMAGE;
  content: ImageContent;
}

interface VideoTip extends BaseTip {
  category: TIP_CATEGORY.VIDEO;
  content: VideoContent;
}

interface MultiImageTip extends BaseTip {
  category: TIP_CATEGORY.MULTI_IMAGE;
  content: MultiImageContent;
}

export type Tip = ImageTip | VideoTip | MultiImageTip;

export interface TipsModalProps {
  show: boolean;
  onClose: () => void;
}
